// extracted by mini-css-extract-plugin
module.exports = {"wallet-icon":"WalletIcon_wallet-icon__1MG2R"};